// import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Todo from "./todo"
import { useState } from 'react';

import {Todocontext} from "../context/todoscontext"

import { useContext } from 'react';

import { v4 as uuidv4 } from 'uuid';//يصنع لي اي دي ديناميكي بدل ماتجلس تعمل اي دي انت 
            //حق useefact
 import { useEffect , useMemo } from 'react';  
import { Toastcontext } from '../context/toastcontext';
// عملنا اري نشوف كيف عتطلع في المشروع عن طريق وضع اي دي 
// const inisinaltodos=[
//   {
//     id:uuidv4(),
//     tittle:"قراعه كتاب ",
//     detals:"kjkhklhkl",
//     iscomplet:false,
//   },
//   {
//     id:uuidv4(),
//     tittle:"قراعه كتاب ",
//     detals:"kjkhklhkl",
//     iscomplet:false,
//   },
//   {
//     id:uuidv4(),
//     tittle:"قراعه كتاب ",
//     detals:"kjkhklhkl",
//     iscomplet:false,
//   },
// ]

export default function Todolist() {
  // console.log("re render")
   const{todos,settodos}=useContext(Todocontext);//جايه من القيمه حق الكونتكس 
   const{Showhidetoast}=useContext(Toastcontext) 
   // const[todos,settodos]=useContext(Todocontext);//useState(inisinaltodos)القيمه الاابتدائيه هي المصفوفه
   const[tittleinput,setinputt]=useState("");//inputالقيمه ,setinput التعديل حق القيمه 
   const[displaytodostype,setdisplaytodostype]=useState("all")
   
   
  useEffect(()=>{ 
  //   console.log("callge use efact") 
  // },[tittleinput]);             فقطtittleinputلل addvences يعمل 
 
    console.log("callge use efact")
    const storgtodos=JSON.parse(localStorage.getItem("toodos"))??[];//??[]هاذا عند الرفع يقولك غلط في الفلتر اضفنا هاذا عشان يبد المشروع خالي من التودو    
    settodos(storgtodos);
  },[]);//مايستدعي الا لما يعمل اعاده تحميل الصفحه

 
  function handaladdclick(){
    // alert ("add")
    const newtodo=
      {
        id:uuidv4(),
        tittle:tittleinput,
        detals:"" ,
        iscomplet:false,//اي قيمه جديده تبدا بفولس ولما تنضاف ترجع ترو

      }
      
    // settodos([...todos,newtodo]);
    // setinputt("")//عند الااضافه تكون خاليه بعد الااضافه

    // localstorge
    // localStorage.setItem("toodos",JSON.stringify(todos))بدون تخزين في اللوكل اضفناها بس
    // setinputt("")
  //    const updatetodo=[...todos,newtodo]
  //   settodos(updatetodo);
  //   Showhidetoast("تم الااضافه بنجاح");//داله حق الااضافه 

  //   localStorage.setItem("toodos",JSON.stringify(updatetodo))//بتخزين في اللوكل اضفناه وحفضناه
  //   setinputt("")
  // }
     const updatetodo=[...todos,newtodo]
    settodos(updatetodo);
    Showhidetoast("تم الااضافه بنجاح");//داله حق الااضافه 

    localStorage.setItem("toodos",JSON.stringify(updatetodo))//بتخزين في اللوكل اضفناه وحفضناه
    setinputt("")
  }
  // function  handalcheke(todoid){
    
  //   // alert("in parint"+todoid)      todoid=>>childمرسل من ال   todoid===>>parmiterتسميه ايي شي لانه كانه عرفنا متغير 
  //   const updatetodoid=todos.map((t)=>{
  //     if(t.id==todoid){
  //       if(t.iscomplet==true){
  //         t.iscomplet=false
  //       }else{
  //         t.iscomplet=true
  //       }
       
  //     }
  //      return t;
      
  //   });
  //   settodos(updatetodoid);


  // }
// const completedtodo=useMemo(()=>{// useMemo-  خيراتعيدخلهن المستخدمtodoخاصة عند التعامل مع عمليات معقدة أو مصفوفات كبيرة.واحنامعانا 
//   return todos.filter((t)=>{//داله تستدعي الذي فيها صح
//     console.log("usememo complit")
//     return t.iscomplet==true;
     
//     // console.log("usememo complit")
// },[todos]);


  const completedtodo=todos.filter((t)=>{//useMemoداله تستدعي الذي فيها صح بدون 
    return t.iscomplet==true;
  })
  const notcompletedtodo=todos.filter((t)=>{//useMemoداله تستدعي الذي مابش فيها صح ....بدون 
    return t.iscomplet==false
    })
// const notcompletedtodo= useMemo(()=>{// useMemo-  خيراتعيدخلهن المستخدمtodoخاصة عند التعامل مع عمليات معقدة أو مصفوفات كبيرة.واحنامعانا 
//   return todos.filter((t)=>{//داله تستدعي الذي مابش فيها صح
//     console.log("not complit")
//     return t.iscomplet==false
// },[todos]);
//   })
  
  let todotoberender=todos;//متغير يعمل على ارجاع ماتم همسه من الكل او المنجز او غير المنجز 
  if(displaytodostype=="complited"){//تعرض لي الذي فيها صحcomplitedاذا همس على الذي فيها قيمه 
    todotoberender=completedtodo;  
  }else if(displaytodostype=="non-complited"){//تعرض لي الذي فيها مش صحcomplitedاذا همس على الذي فيها قيمه 
    todotoberender=notcompletedtodo;
  }
  // else if(todotoberender.length==5){
  //   return <div> <h1  style={{textAlign:'center', backgroundColor:'red', color:'white'}}>
  //     لايوجد اي مهام من فضلك قم باضافه مهام ؟!
  //   </h1>
    
  //   </div>  
  // }
  // else{
  //   todotoberender=todos//تردلك النورمل الطبيعي 
  // }
   const todosjsx=todotoberender.map((t)=>{//تعمل ماب في النتيجه الذي عتهمسها 
    // return<Todo key={t.id} tittle={t.tittle} detals={t.detals}/>// tittle,detals===>todoهولا البروبس الذي عيعرضها في ال 

       return<Todo key={t.id} todo={t} /> 
  });
  function chaingdisplaytodo(e){//حق التضليل لما يهمس الماوس
    setdisplaytodostype(e.target.value)
  }
  return (
    
    <Container maxWidth='sm'style={{textAlign:"center"}} >
       
     <Card sx={{ minWidth: 275 }}
     style={{maxHeight:"100vh",
      overflow:"scroll",
     }}
     >
      <CardContent>
        <Typography variant='h2' style={{fontFamily:"athen",marginBottom:"20px"}} >مهامي </Typography>

       {/* الخط Divider*/}
        <Divider/>
      

        {/* ToggleButton */}

         <ToggleButtonGroup
      color="primary"
     
      exclusive
      value={displaytodostype}//عرض الكل الذي هي فيها صح ومابش فيها صح
      onChange={chaingdisplaytodo}//عند ضغط واحد من البوتن حق الكل او المنجز او الغير منجز بحيث انه يضلل المكان الذي ضغطه  
      
      aria-label="Platform"
    >
        
      <ToggleButton value="all" style={ {fontFamily:"a" }}>الكل</ToggleButton>
      <ToggleButton value="complited"style={ {fontFamily:"a"}}>المنجز</ToggleButton>
      <ToggleButton value="non-complited" style={ {fontFamily:"a"}}>غير المنجز</ToggleButton>
    </ToggleButtonGroup>
      <p      
        style={{textAlign:'center', backgroundColor:'gray', color:'white'}}>
          المهام المتواجده 
         ({todosjsx.length}){/* يعرض عدد المهام المتواجده */}
          </p> 
      

    {todosjsx}{/* يعرض المهام */}

   
    

       {/* input + button */}
      <Grid container>
         <Grid
         xs= {8}
         display="flex"
         justifyContent="space-around"
         alignItems="center"
         style={{background:"white",width:"75%"}}>
            <TextField
            
             id="outlined-basic" 
             label="عنوان الكتاب"
              variant="outlined"              
             style={{width:"100%",marginTop:"10px"}} 
             value={tittleinput}//القيمه 
             onChange={(e)=>{//{عند الكتابه تضيف ماكتبه في القيمه
              setinputt(e.target.value)//يضيف الذي كتبناه في القيمه 
             }}


             />

         </Grid>
         <Grid
         xs= {4}
         display="flex"
         justifyContent="space-between"
         alignItems="center"
         style={{background:"white",width:"25%",marginTop:"10px"}}>
           <Button variant="text" 
           disabled={tittleinput.length==0}//اذا مادخل شي في التيكست طلع له انه ماينفع يرسل شي
           onClick={()=>{handaladdclick()}}  
           className='btn'
           style={{width:"100%",
           border:"solid black 2px",
           height:"60px",margin:"2px",
           background:"gray",color:"white",
           fontFamily:"athen",
           cursor:"pointer",
           }}
          >
            اضافه
            </Button>

         </Grid>
      </Grid>
       {/* input + button */}
        <p      
        style={{textAlign:'center', backgroundColor:'gray', color:'white'}}>
          المهام المتواجده 
         ({todosjsx.length}){/* يعرض عدد المهام المتواجده */}
          </p> 
              <div>
      <p   
            style={{textAlign:'center', backgroundColor:"gray", color:'white'}}>
            <marquee direction="lift" scrollamount="10">
            <h1>Yahya Ahhmd Alhaifi ...... Tell:+967 771940086 ...... Email:yahayaalhaifi@gmail.com</h1> 
            </marquee>
        </p>  
      </div>
      </CardContent>
      <CardActions>
        <Button size="small" style={{background:"green",color:"white"}}>Learn More</Button>
      </CardActions>
    </Card>
       {/* <div>     */}
       {/* <h1 style={{fontFamily:"a"}}>yahyaha </h1>
        <h1 style={{fontFamily:"athen"}}>yahyaha </h1> */}
        {/* <h1 style={{fontFamily:"athen2"}}>yahyaha </h1>
        <h1 style={{fontFamily:"athen3"}}>yahyaha </h1>
        <h1 style={{fontFamily:"athen"}}>yahyaha </h1> */}
       {/* </div> */} 
      </Container>
   
  );
}